export default __webpack_public_path__ + "static/media/amazon-case.7ca03393.jpg";